module.exports = __webpack_public_path__ + "img/american-express.d25e4d9d.svg";